import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'material-ui/Popover'
import SearchBox from 'billing/common/SearchBox'
import ContactList from './ContactList'
import { CustomerLabel } from './CustomerAccessories'

import * as firebase from 'firebase'
import _ from 'lodash'

class CustomerSelector extends React.PureComponent {

  static propTypes = {
    customerId: PropTypes.string,
    teamId: PropTypes.string,
    contactId: PropTypes.string,
    showLabel: PropTypes.bool,
    label: PropTypes.string,
    onSelection: PropTypes.func,
    onInputClick: PropTypes.func,
    onCloseRequest: PropTypes.func,
    showPopover: PropTypes.bool
  }

  constructor(props){
    super(props)
    this.state = {
      query: '',
      customer: {}
    }
  }

  componentWillMount(){
    if (this.props.customerId){
      this.attachListener(
        this.props.customerId,
        this.props.teamId,
        this.props.contactId
      )
    }
  }

  componentWillReceiveProps(nextProps){
    if (this.props.customerId !== nextProps.customerId
        || this.props.contactId !== nextProps.contactId){
      this.deattachListener( this.props.customerId, this.props.teamId )

      this.attachListener(
        nextProps.customerId,
        nextProps.teamId,
        nextProps.contactId
      )
    }
  }

  componentWillUnmount(){
    this.deattachListener( this.props.customerId, this.props.teamId )
  }

  deattachListener = (customerId, teamId) => {
    if (customerId){
      firebase.database()
        .ref(`customers/${teamId}`)
        .orderByKey()
        .equalTo(customerId)
        .off('value', this.dbFunction)
    }

  }

  attachListener(customerId, teamId, contactId){
    this.dbFunction = this.onReturn.bind(this, contactId)
    firebase.database()
      .ref(`customers/${teamId}`)
      .orderByKey()
      .equalTo(customerId)
      .on('value', this.dbFunction)
  }

  onReturn = (contactId, snapshots) => {
    let customer = null
    //Should only be one match
    snapshots.forEach(snapshot => customer = snapshot.val())
    const contact = customer.contactsList[contactId]
    if (customer && contact){
      this.setState({ customer, contactId })
      //update parent
      this.props.onSelection(customer, contact)
    } else if (customer){
      this.setState({ customer })
    } else {
      this.setState({ error: 'Customer has been deleted.'})
    }
  }

  onQueryChange = (query) => {
    this.setState({ query })
  }

  filterContacts = (customer, query) => {
    if (!customer){
      //attaching loader
      return []
    }

    const contactsList = customer.contactsList
    if (!query){
      return _.keys(contactsList).map(id => contactsList[id])
    } else {
      const results = []
      _.keys(contactsList).forEach(id => {
        const contact = contactsList[id]
        if (contact.contactName.toLowerCase().indexOf(query.toLowerCase()) !== -1){
          results.push(contact)
        }
      })
      return results
    }
  }

  render () {
    const onInputClick = this.props.customerId ? this.props.onInputClick : () => {}
    const editableColor = this.props.customerId ? 'rgba(0, 0, 0, 0.6)' : 'rgb(217, 217, 217)'
    const { customer, query } = this.state
    const filteredContacts = this.filterContacts(customer, query)
    const contact = customer.contactsList && customer.contactsList[this.props.contactId]
    return (
      <div>
        {
          this.props.showLabel
          &&
          <CustomerLabel label={this.props.label} color={editableColor}/>
        }
        <div style={{flexDirection: 'row'}}>
          <input
            ref={e => { this.contactInput = e }}
            placeholder={'Select Contact'}
            style={styles.input(Boolean(this.props.customerId))}
            value={(contact && contact.contactName) ? contact.contactName : ''}
            onClick={onInputClick}
            readOnly={true}/>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: 'pointer' }}
            width="20"
            height="20"
            viewBox="0 0 18 18"
            onClick={onInputClick}>
            <path d="M5 8l4 4 4-4z" fill={editableColor}/>
          </svg>
        </div>

        <Popover
          open={this.props.showPopover}
          anchorEl={this.contactInput}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          style={{ borderRadius: 4, width: 290 }}
          useLayerForClickAway={false} // Avoid flashy effect when rendering the popover.
          onRequestClose={this.props.onCloseRequest}>
          <SearchBox
            style={{width:275}}
            onValueChanged={this.onQueryChange}/>
          <ContactList
            customer={customer}
            contacts={filteredContacts}
            onSelection={this.props.onSelection.bind(this, customer)}/>
        </Popover>
      </div>
    )

  }
}

export default CustomerSelector

const styles = {
  input: enabled => ({
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    color: '#4a4a4a',
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    outlineWidth: 2,
    width: 275,
    cursor: enabled ? 'pointer' : 'not-allowed',
    marginBottom: 16
  })
}



// WEBPACK FOOTER //
// ./src/customer/ContactSelector.js